export default __webpack_public_path__ + "static/media/empstatusicon.643e4229.svg";